export default {
  0: '指定なし',
  1: '完全個室',
  2: '半個室',
}
